import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Loading from './Loading';

const Blog = () => {
    const [blog, setBlog] = useState({});
    const { id } = useParams();
    const getBlog = async () => {
        const { data } = await axios.get(`https://hr-meheraj-portfolio.herokuapp.com/blogs/${id}`);
        setBlog(data);
    }
    useEffect(() => {
        getBlog();
    }, [id])
    if (!blog) {
        return <Loading />
    }
    return (
        <div className='mx-auto max-w-[720px] w-[95%] my-[40px]'>
            <img className='w-full rounded-md mb-4' src={blog?.imgURL} alt={blog?.title} />
            <h2 className='text-xl sm:text-2xl md:text-4xl text-white mb-3'>{blog?.title}</h2>
            <p className='text-[#c4cbd0]'>{blog?.body}</p>
            <a className='link mt-[20px] text-[#00b1ff]' href='mailto:habib.meheraj@gmail.com font-semibold'>Author : {blog?.author}</a>
        </div>
    );
}

export default Blog;
